module.exports = __webpack_public_path__ + "static/media/music.9ed4a830.png";